import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowRotateRightOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowRotateRightOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="currentColor">
        <path d="M13.955 11.5h2.48l3.68-5-3.68-5h-2.48l2.95 4h-7.02c-3.31 0-6 2.69-6 6v7h2v-7c0-2.21 1.79-4 4-4h7.02l-2.95 4Z" />
        <path d="M15.885 13.5h-3c-1.66 0-3 1.34-3 3v3c0 1.66 1.34 3 3 3h3c1.66 0 3-1.34 3-3v-3c0-1.66-1.34-3-3-3Zm1 6c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v3Z" />
      </g>
    </svg>;
}) as ForwardedIconComponent);
export default ArrowRotateRightOutlined;